import script from "./DocLibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./DocLibrary.vue?vue&type=script&setup=true&lang=js"

import "./DocLibrary.vue?vue&type=style&index=0&id=e09df7ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e09df7ca"]])

export default __exports__